/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Gradebook info modal
 *
 * @author Satyaki Bose
 * @file GradebookInfoModal.jsx
 */

import React from 'react';
import PropTypes from 'prop-types';
import { GlobalStyles } from '@mui/material';
import CustomModal from '../../common/CustomModal';
import { portalSlotStyles } from './styles/assignmentSettingsFormStyles';

const GradebookInfoModal = ({
  classes,
  open,
  textInfo,
  onClose
}) => (
  <CustomModal
    open={open}
    onClose={onClose}
    classes={{
      paper: classes.infoModalPaper,
      content: classes.infoModalContent,
      closeButton: classes.infoModalCloseButton
    }}
  >
    <GlobalStyles styles={portalSlotStyles} />
    <h2 className={classes.modalTitle}>{textInfo.gradebookInfoModalTitle}</h2>
    <div className={classes.infoModalSections}>
      <div className={classes.modalSection}>
        <p className={classes.modalSectionTitle}>{textInfo.gradebookInfoRawScoreHeading}</p>
        <p className={classes.modalSectionBody}>{textInfo.gradebookInfoRawScoreBody}</p>
      </div>
      <div className={classes.modalSection}>
        <p className={classes.modalSectionTitle}>{textInfo.gradebookInfoEqualWeightingHeading}</p>
        <p className={classes.modalSectionBody}>{textInfo.gradebookInfoEqualWeightingBody}</p>
      </div>
    </div>
  </CustomModal>
);

GradebookInfoModal.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  textInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

GradebookInfoModal.defaultProps = {
  onClose: null
};

export default GradebookInfoModal;
